import { configureStore, combineReducers, applyMiddleware } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userDataReducer from "./user-data/slice";
import mlOpsReducer from "../pages/mlops/ducks/slice";
import cloudServicesReducer from './../pages/cloud-service-provisioning/ducks/slice'; 
import createSagaMiddleware from "redux-saga";
import rootSaga from "./root-saga";
import onboardingReducer from './../pages/onboarding/ducks/slice';
import mlopsAgentReducer from './../pages/mlops-agent/ducks/slice';
import teamDirectoryReducer from './../pages/team-directory/ducks/slice';

// Create a configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userData', 'mlopsAgent'],
};
const saga = createSagaMiddleware();

// Combine your reducers
const rootReducer = combineReducers({
  userData: userDataReducer,
  onboarding: onboardingReducer,
  mlOps: mlOpsReducer,
  cloudServices: cloudServicesReducer,
  mlopsAgent: mlopsAgentReducer,
  teamDirectory: teamDirectoryReducer,
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

applyMiddleware();

// Configure the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(saga),
});

saga.run(rootSaga);

// Set up the persistor
export const persistor = persistStore(store);

// Export RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
